export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_en-983981c623140d1cdae2616368b9d4cc.webp";